// extracted by mini-css-extract-plugin
module.exports = {"FormatModal":"FormatModal_FormatModal__1FZHl","Title":"FormatModal_Title__XdIXu","Content":"FormatModal_Content__18enT"};